<div (click)="$event.preventDefault(); closeModal();"
    class="fixed inset-0 flex items-center justify-center bg-main-background bg-opacity-75 z-20 gap-4">
    <div class="w-full max-w-screen-md h-96 flex flex-row gap-1 justify-center overflow-y-auto" (click)="$event.stopPropagation()">
        <!-- EVENT DETAILS -->
        <div class="flex min-w-full h-full bg-white p-10 rounded-md text-center shadow-lg">
            <form (ngSubmit)="$event.preventDefault(); saveNew();" #resourceForm="ngForm"
                class="w-full flex flex-col items-center justify-start gap-4">
                <div class="w-full flex flex-row gap-8 items-center justify-between pb-4 border-b border-gray-200">
                    <h2
                        class="w-full oswald-font text-xl font-medium text-start whitespace-nowrap text-nside-orange-400">
                        Add a New Basic Resource
                    </h2>
                    <button class="p-1 rounded-full hover:bg-gray-100" (click)="$event.preventDefault(); closeModal();">
                        <lucide-icon [name]="icons.X" [size]="20" class="text-nside-gray-200"></lucide-icon>
                    </button>
                </div>

                <div class="w-full h-full flex flex-col items-center justify-center gap-2 pb-4 border-b border-gray-200">
                    <div class="w-full flex items-center text-start">
                        <div class="w-44 flex items-center text-nside-gray-300">
                            <p>Resource Group:</p>
                        </div>
                        <div class="w-full flex flex-col items-center">
                            <select 
                              name="resource_group"
                              [(ngModel)]="resource.resource_group"
                              class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded block w-full p-2"
                            >
                                <option value="Tools">Tools</option>
                                <option value="Food and Blankets">Food and Blankets</option>
                                <option value="Medical Supplies">Medical Supplies</option>
                                <option value="Recovery (Counseling/Mental Health/Public Health)">Recovery (Counseling/Mental Health/Public Health)</option>
                            </select>
                        </div>
                    </div>

                    <div class="w-full flex items-center text-start">
                        <div class="w-44 flex items-center text-nside-gray-300">
                            <p>Location:</p>
                        </div>
                        <div class="relative w-full h-full flex flex-col items-center">
                            <input type="text" name="location" [(ngModel)]="resource.location" required
                                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded block w-full p-2"
                                placeholder="Create new resource"
                                (focus)="showSuggestions = true"
                                (blur)="hideSuggestions()">
                            <div class="w-full text-start italic text-xs text-red-500"
                                *ngIf="resourceForm.submitted && !resource.location">
                                This field is required.
                            </div>

                            <div *ngIf="showSuggestions && filteredSuggestions.length > 0"
                            class="absolute top-full left-0 mt-1 z-20 divide-y divide-gray-300 bg-white rounded-md w-full shadow-md max-h-48 overflow-y-auto">
                                <ul class="p-2">
                                    <li 
                                        *ngFor="let suggestion of filteredSuggestions" 
                                        (mousedown)="selectSuggestion(suggestion)"
                                        class="px-3 py-2 cursor-pointer hover:bg-gray-100"
                                    >
                                        {{ suggestion }}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="w-full flex items-center text-start">
                        <div class="w-44 flex items-center text-nside-gray-300">
                            <p>Resources:</p>
                        </div>
                        <div class="relative w-full h-full flex flex-col items-center">
                            <input type="text" name="resources" [(ngModel)]="resource.resources" required
                                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded block w-full p-2"
                                placeholder="Resources">
                            <div class="w-full text-start italic text-xs text-red-500"
                                *ngIf="resourceForm.submitted && !resource.location">
                                This field is required.
                            </div>
                        </div>
                    </div>
                    
                    <div class="w-full flex items-center text-start">
                        <div class="w-44 flex items-center text-nside-gray-300">
                            <p>Contact:</p>
                        </div>
                        <div class="w-full flex flex-col items-center">
                            <select 
                              name="contact_id"
                              [(ngModel)]="resource.contact_id"
                              class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded block w-full p-2"
                            >
                                <option *ngFor="let contact of contactsList" [value]="contact.id">
                                    {{ contact.name }} - {{ contact.email }}
                                </option>
                            </select>
                        </div>
                    </div>

                </div>

                <!-- Buttons -->
                <div class="w-full flex flex-row gap-2 items-center justify-end">
                    <button (click)="$event.preventDefault(); closeModal();"
                        class="px-4 py-1.5 w-20 rounded-md border border-nside-gray-400 oswald-font">
                        Close
                    </button>
                    <button 
                        type="submit"
                        class="w-20 flex items-center justify-center px-4 py-1.5 rounded-md border bg-gradient-to-b oswald-font text-white"
                        [ngClass]="{
                            'border-nside-gray-100 from-nside-gray-100 to-nside-gray-200 cursor-not-allowed': !resource.location || !resource.resources,
                            'border-nside-orange-100 from-nside-orange-300 to-nside-orange-400 hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200': resource.location && resource.resources
                        }" 
                        [disabled]="!resource.location || !resource.resources"
                    >
                        Save
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>

<div *ngIf="loading">
    <spinner></spinner>
</div>